// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ofSHmgkZ>*+*{margin-top:max(2.63rem,min(2.92vw,3.5rem))}._7hErymaT{display:grid;grid-gap:1.25rem;gap:1.25rem}@media(min-width:667.98px){._7hErymaT{grid-template-columns:1fr 1fr}}.g6qBfF-G{background:#f5f6ff;border-radius:max(2rem,min(2.08vw,2.5rem));overflow:hidden;padding:max(2rem,min(2.08vw,2.5rem));position:relative}.g6qBfF-G:nth-child(2n){--color-title:#32388c}.g6qBfF-G>*{position:relative}.g6qBfF-G>*+*{margin-top:.5rem}.rvVVOoog{bottom:0;height:auto;pointer-events:none;position:absolute;right:max(-1.25rem,min(-1.04vw,-.7rem));-webkit-user-select:none;-moz-user-select:none;user-select:none;width:max(7.03rem,min(10.42vw,12.5rem))}.mC7NmkLO{color:var(--color-title,var(--color-primary));font-size:max(1.5rem,min(2.08vw,2.5rem));line-height:.87;margin-bottom:max(.75rem,min(.94vw,1.13rem))}.DPcfLuBt,.mC7NmkLO{text-transform:uppercase}.DPcfLuBt{font-size:max(1.13rem,min(1.04vw,1.25rem));line-height:1}.UVtvnFeB{color:var(--color-gray-4);font-size:.88rem;font-weight:500;line-height:1.6}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"xl": "1920.98",
	"container": "ofSHmgkZ",
	"cards": "_7hErymaT",
	"card": "g6qBfF-G",
	"cardBg": "rvVVOoog",
	"cardTitle": "mC7NmkLO",
	"cardDate": "DPcfLuBt",
	"cardText": "UVtvnFeB"
};
module.exports = ___CSS_LOADER_EXPORT___;
